import React from "react";

function DriverAssessment() {
  return (
    <>
      <style>
        {`
          /* CSS for print functionality */
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page by default */
            }
            #DriverAssessment, #DriverAssessment * {
              visibility: visible; /* Make only the form and its children visible */
            }
            #DriverAssessment {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide the print button when printing */
            .print-button {
              display: none;
            }
            /* Ensure input fields and textareas are visible and readable when printed */
            input, textarea {
                border: 1px solid #000 !important;
                background-color: transparent !important;
            }
          }
        `}
      </style>

      <div id="DriverAssessment" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Driver Assessment Form</h3>

        <form>
          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Driver Licence No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="licenceNo">
              Driver Licence No.:
            </label>
            <input
              type="text"
              id="licenceNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver licence number"
            />
          </div>

          {/* Driver CPC No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="cpcNo">
              Driver CPC No.:
            </label>
            <input
              type="text"
              id="cpcNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver CPC number"
            />
          </div>

          {/* Date of Assessment */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="assessmentDate">
              Date of Assessment:
            </label>
            <input
              type="date"
              id="assessmentDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Assessor Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="assessorName">
              Assessor Name:
            </label>
            <input
              type="text"
              id="assessorName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter assessor name"
            />
          </div>

          {/* Assessment Type */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="assessmentType">
              Assessment Type:
            </label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="radio" name="assessmentType" value="Initial" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Initial</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="assessmentType" value="Periodic" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Periodic</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="assessmentType" value="Incident Review" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Incident Review</span>
              </label>
            </div>
          </div>

          {/* Assessment Criteria */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="assessmentCriteria">
              Assessment Criteria:
            </label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="drivingSkills" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Driving Skills</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="knowledgeOfRegs" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Knowledge of Regulations</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="vehicleFamiliarity" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Vehicle Familiarity</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="safetyAwareness" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Safety Awareness</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="communicationSkills" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Communication Skills</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" name="other" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Other (specify)</span>
              </label>
            </div>
          </div>

          {/* Overall Assessment Result */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="overallResult">
              Overall Assessment Result:
            </label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallResult" value="Pass" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Pass</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallResult" value="Fail" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Fail</span>
              </label>
            </div>
          </div>

          {/* Comments */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="comments">
              Comments:
            </label>
            <textarea
              id="comments"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Add any additional comments here..."
            />
          </div>

          {/* Signatures */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="assessorSignature">
              Signature of Assessor:
            </label>
            <input
              type="text"
              id="assessorSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Assessor Signature"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverSignature">
              Signature of Driver:
            </label>
            <input
              type="text"
              id="driverSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Driver Signature"
            />
          </div>

          {/* Date of Next Assessment */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="nextAssessmentDate">
              Date of Next Assessment:
            </label>
            <input
              type="date"
              id="nextAssessmentDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </form>

        {/* Print Button */}
        <div className="mt-6 text-right print-button">
          <button
            type="button"
            onClick={() => window.print()}
            className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg"
          >
            Print Form
          </button>
        </div>
      </div>
    </>
  );
}

export default DriverAssessment;